var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("@/assets/reportLost.png"),"alt":""}}),_c('div',[_vm._v(" 当前页面已失效 ")])])])
}]

export { render, staticRenderFns }